module.exports = __webpack_public_path__ + "assets/Modal-Close-Dark.a73a5cb2.svg";